import { Flex } from "@chakra-ui/react";
import { AverageDurationRadialChart } from "../../dashboard/charts/v2/AverageDurationRadialChart";
import BasePageTitleContainer from "../../form/BasePageTitleContainer";

interface metric {
  totalDuration: number;
  averageDuration: number;
}

export const AverageDurationCard = ({
  metric,
  runCount,
}: {
  metric: metric;
  runCount: number;
}) => {
  return (
    <BasePageTitleContainer
      height="168px"
      width="100%"
      maxWidth="100%"
      mx="0px"
    >
      <Flex flexDir="column" justifyContent="center" alignItems="center">
        <div>
          <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
            Average duration — Last {runCount} attempts
          </p>
        </div>
        <AverageDurationRadialChart data={metric} />
      </Flex>
    </BasePageTitleContainer>
  );
};
